const publicFilePath = process.env.VUE_APP_PUBLIC_FILE_PATH;

const getPath = (filePath) => `${publicFilePath}${filePath}`;

export default {
  getPath,
};
